export const NIRMATA_LIGHT_THEME = {
  base: 'vs',
  inherit: true,
  rules: [],
  colors: {
    'editor.background': '#f9fafc', // --background
    'editor.foreground': '#181a20', // --foreground
    'editor.lineHighlightBackground': '#f9fafc', // --muted
    'editor.selectionBackground': '#2563eb22', // --primary (with opacity)
    'editor.inactiveSelectionBackground': '#64748b33', // --secondary (with opacity)
    'editorCursor.foreground': '#2563eb', // --primary
    'editor.lineHighlightBorder': '#e5e5e5', // --border
    'editorLineNumber.foreground': '#788299', // --muted-foreground
    'editorLineNumber.activeForeground': '#2563eb', // --primary
    'editorIndentGuide.background': '#e5e5e5', // --border
    'editorIndentGuide.activeBackground': '#2563eb', // --primary
    'editor.selectionHighlightBackground': '#2563eb22', // --primary (with opacity)
    'editor.wordHighlightBackground': '#f5f5f7', // --popover
    'editor.wordHighlightStrongBackground': '#64748b33', // --secondary (with opacity)
    'editorBracketMatch.background': '#f5f5f7', // --popover
    'editorBracketMatch.border': '#2563eb', // --primary
    'editorGutter.background': '#f9fafc', // --background
    'editorError.foreground': '#ef4444', // --destructive
    'editorWarning.foreground': '#f1c40f', // --accent
    'editorWidget.background': '#f5f5f7', // --popover
    'editorWidget.border': '#e5e5e5', // --border
    'editorSuggestWidget.background': '#f5f5f7', // --popover
    'editorSuggestWidget.border': '#e5e5e5', // --border
    'editorSuggestWidget.foreground': '#181a20', // --foreground
    'editorSuggestWidget.selectedBackground': '#2563eb22', // --primary (with opacity)
    'editorSuggestWidget.highlightForeground': '#2563eb', // --primary
    'scrollbarSlider.background': '#e5e5e580', // --border (with opacity)
    'scrollbarSlider.hoverBackground': '#2563eb22', // --primary (with opacity)
    'scrollbarSlider.activeBackground': '#2563eb', // --primary
  },
  encodedFonts: ['Fira Code', 'monospace'],
};

export const NIRMATA_DARK_THEME = {
  base: 'vs-dark',
  inherit: true,
  rules: [],
  colors: {
    'editor.background': '#181a20', // --background
    'editor.foreground': '#f4f4f5', // --foreground
    'editor.lineHighlightBackground': '#23262f', // --muted
    'editor.selectionBackground': '#60a5fa22', // --primary (with opacity)
    'editor.inactiveSelectionBackground': '#64748b33', // --secondary (with opacity)
    'editorCursor.foreground': '#60a5fa', // --primary
    'editor.lineHighlightBorder': '#393e4b', // --border
    'editorLineNumber.foreground': '#a1a1aa', // --muted-foreground
    'editorLineNumber.activeForeground': '#60a5fa', // --primary
    'editorIndentGuide.background': '#393e4b', // --border
    'editorIndentGuide.activeBackground': '#60a5fa', // --primary
    'editor.selectionHighlightBackground': '#60a5fa22', // --primary (with opacity)
    'editor.wordHighlightBackground': '#232b3a', // --popover
    'editor.wordHighlightStrongBackground': '#64748b33', // --secondary (with opacity)
    'editorBracketMatch.background': '#232b3a', // --popover
    'editorBracketMatch.border': '#60a5fa', // --primary
    'editorGutter.background': '#181a20', // --background
    'editorError.foreground': '#ef4444', // --destructive
    'editorWarning.foreground': '#fbbf24', // --accent
    'editorWidget.background': '#232b3a', // --popover
    'editorWidget.border': '#393e4b', // --border
    'editorSuggestWidget.background': '#232b3a', // --popover
    'editorSuggestWidget.border': '#393e4b', // --border
    'editorSuggestWidget.foreground': '#f4f4f5', // --foreground
    'editorSuggestWidget.selectedBackground': '#60a5fa22', // --primary (with opacity)
    'editorSuggestWidget.highlightForeground': '#60a5fa', // --primary
    'scrollbarSlider.background': '#393e4b80', // --border (with opacity)
    'scrollbarSlider.hoverBackground': '#60a5fa22', // --primary (with opacity)
    'scrollbarSlider.activeBackground': '#60a5fa', // --primary
  },
  encodedFonts: ['Fira Code', 'monospace'],
};
